import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RoomType} from '../../../enums/RoomType';
import {Office} from '../../../classes/Office';

@Component({
  selector: 'app-office-edit',
  styleUrls: ['./office-edit.component.scss'],
  templateUrl: './office-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class OfficeEditComponent implements OnInit {

  @Input() office: Office;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  types: string[];

  public officeForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder) {}

  ngOnInit(): void {

    this.types = Object.keys(RoomType);

    if (this.office) {
      this.officeForm = this.formBuilder.group({
        id: [this.office.id],
        city: [this.office.city, Validators.required],
        address: [this.office.address, Validators.required],
        phone: [this.office.phone, Validators.required],
        timeZone: [this.office.timeZone, Validators.required],
        zkTecoHost: [this.office.zkTecoHost],
        zkTecoPort: [this.office.zkTecoPort]
      });
    } else {
      this.officeForm = this.formBuilder.group({
        id: [''],
        city: ['', Validators.required],
        address: ['', Validators.required],
        phone: ['', Validators.required],
        timeZone: ['Asia/Jerusalem', Validators.required],
        zkTecoHost: [''],
        zkTecoPort: ['']
      });
    }
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
